import React from 'react';
import { LegoBaseplateGrid } from './LegoBaseplateGrid';
import { LegoLetter } from './LegoLetter';
import { BASEPLATE_SIZES, BaseplateSize, LegoSize } from '../../types/LegoTypes';
import {
  getLetterColumnOffset,
  getLetterRowOffset,
  getVerticalCenterRowOffset,
  STUD_PX,
} from '../../utils/legoLayout';
import './LegoBuilder.css';

interface LegoBaseplateProps {
  rows: string[][];
  size: LegoSize;
  baseplate: BaseplateSize;
}

export const LegoBaseplate: React.FC<LegoBaseplateProps> = ({ rows, size, baseplate }) => {
  const { baseWidth, baseHeight } = BASEPLATE_SIZES[baseplate];
  const verticalCenterOffset = getVerticalCenterRowOffset(rows.length, size, baseplate);

  return (
    <div
      className='lego-baseplate-surface'
      style={{
        width: `${baseWidth * STUD_PX}px`,
        height: `${baseHeight * STUD_PX}px`,
        ['--stud-px' as string]: `${STUD_PX}px`,
      }}
    >
      <LegoBaseplateGrid cols={baseWidth} rows={baseHeight} />
      {rows.map((row, rowIndex) =>
        row.map((letter, columnIndex) => (
          <LegoLetter
            key={`${rowIndex}-${columnIndex}-${letter}`}
            letter={letter}
            size={size}
            columnOffset={getLetterColumnOffset(columnIndex, size)}
            rowOffset={verticalCenterOffset + getLetterRowOffset(rowIndex, size)}
          />
        )),
      )}
    </div>
  );
};
